import { render, staticRenderFns } from "./CustomisedcontractorRequestCard.vue?vue&type=template&id=0965b701"
import script from "./CustomisedcontractorRequestCard.vue?vue&type=script&lang=ts"
export * from "./CustomisedcontractorRequestCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0965b701')) {
      api.createRecord('0965b701', component.options)
    } else {
      api.reload('0965b701', component.options)
    }
    module.hot.accept("./CustomisedcontractorRequestCard.vue?vue&type=template&id=0965b701", function () {
      api.rerender('0965b701', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/card/CustomisedcontractorRequestCard.vue"
export default component.exports